import { render } from "./sick-leave-modal.vue?vue&type=template&id=fdc33104&scoped=true"
import script from "./sick-leave-modal.vue?vue&type=script&lang=js"
export * from "./sick-leave-modal.vue?vue&type=script&lang=js"

import "./sick-leave-modal.vue?vue&type=style&index=0&id=fdc33104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdc33104"]])

export default __exports__